/**
 * Bu xato ESKI SAHIFADAN kelganmi (deploy'dan keyingi eng ko'p
 * uchraydigan holat).
 *
 * NIMA BO'LADI. Next.js sahifani bo'laklarga bo'lib yuboradi va har
 * bo'lak nomida build hash'i turadi (`chunks/4821-a3f9.js`). Deploy
 * yangi hash'lar bilan keladi, eskilari esa serverdan YO'QOLADI.
 * Odamning tabi ochiq qolgan bo'lsa, u hamon eski HTML bilan
 * o'tiribdi — va birinchi navigatsiyada brauzer mavjud bo'lmagan
 * bo'lakni so'raydi va 404 oladi.
 *
 * NEGA BU ALOHIDA AJRATILADI. Odatdagi xatoda `reset()` mantiqiy:
 * u komponentni qayta chizadi va ko'pincha yordam beradi. Eski
 * build'da esa u YORDAM BERMAYDI — qayta chizish o'sha yo'q
 * bo'lakni yana so'raydi. Kerakli narsa bitta: sahifani to'liq
 * qayta yuklash, ya'ni yangi HTML va yangi hash'larni olish.
 *
 * "Qayta urinish" tugmasini bosib-bosib hech narsa bo'lmasligi —
 * odam uchun sayt butunlay buzilgandek ko'rinadi.
 */
const SIGNS = [
  // Webpack / Next.js
  "ChunkLoadError",
  "Loading chunk",
  "Loading CSS chunk",
  // Vite va zamonaviy ESM
  "Failed to fetch dynamically imported module",
  "error loading dynamically imported module",
  "Importing a module script failed",
];

export function isStaleBuildError(error: unknown): boolean {
  if (!error) return false;

  const name = error instanceof Error ? error.name : "";
  const message = error instanceof Error ? error.message : String(error);
  const haystack = `${name} ${message}`;

  return SIGNS.some(sign => haystack.includes(sign));
}
